/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import DailyClosingEvent from '../../event/DailyClosingEvent'
import { List, Record } from 'immutable'

const EditViewState = Record({
  deleted_ids: List(),
  deleted_reservation_ids: List()
})

class EditViewStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new EditViewState()
  }

  reduce(state, action) {
    const payload = action.payload
    const _state = state

    switch (action.type) {
      case DailyClosingEvent.onDeleteDetail:
        if (!payload.id) return state
        return state.set('deleted_ids', _state.deleted_ids.push(payload.id))

      case DailyClosingEvent.onDeleteReservation:
        if (!payload.reservation_id) return state
        const matched = state.deleted_reservation_ids.findIndex(reservation_id => reservation_id == payload.reservation_id)
        if (matched !== -1) return state
        return state.set('deleted_reservation_ids', _state.deleted_reservation_ids.push(payload.reservation_id))

      case DailyClosingEvent.onClear:
        return state.clear()

      default:
        return state
    }
  }
}

export default new EditViewStore()
